<template>
    <vx-expandable-card>
        <template v-slot:header> Extra Billing Information </template>
        <template v-slot:content>
            <form @submit.prevent="submit" class="flex flex-col gap-6 mt-3">
                <vx-alert data-test="info-alert" :closeable="false">
                    <template v-if="canUpdate">
                        This information will appear on all of your receipts, and is a great place to add your full
                        business name or address of record. Do not include any confidential or financial information
                        such as credit card numbers.
                    </template>
                    <template v-else> Extra billing information may only be set/changed by the team owner. </template>
                </vx-alert>

                <vx-input
                    :rows="7"
                    v-model="data.information"
                    style="font-family: monospace"
                    :disabled="!canUpdate"
                    size="lg"
                    :error="displayFirstError(validation.information)"
                ></vx-input>

                <vx-button v-if="canUpdate" size="lg" type="submit" :loading="processing">
                    Update
                </vx-button>
            </form>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxAlert, VxButton, VxInput, VxExpandableCard } from '@voxie/frontend-components';
import { computed, ref } from 'vue';
import { useFormSubmission } from '~/composables/useFormSubmission';
import { displayFirstError } from '~/utils/validation';
import axios from '~/services/axios';

const props = defineProps({
    team: {
        type: Object,
        required: true,
    },
    ownsTeam: Boolean,
    isTeamAdmin: Boolean,
});

const data = ref({
    information: props.team.extra_billing_information,
});

const canUpdate = computed(() => props.ownsTeam || props.isTeamAdmin);

const { validation, submit, processing } = useFormSubmission({
    data,
    submit: () => axios.put(`/settings/teams/${props.team.id}/extra-billing-information`, data.value),
    notification: {
        message: 'Extra Billing Information updated',
    },
});
</script>
